import React from 'react';
import {
  Switch,
  FormControlLabel,
  FormHelperText,
  FormControl,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  errorText: {
    marginTop: 0,
    marginLeft: 14,
  },
});

export interface BooleanInputProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  error?: string;
  className?: string;
  'data-cy'?: string;
}

export const BooleanInput: React.FC<BooleanInputProps> = ({
  label,
  checked,
  onChange,
  disabled = false,
  error,
  className,
  'data-cy': dataCy,
}) => {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <FormControl
      className={`${classes.root} ${className || ''}`}
      error={!!error}
    >
      <FormControlLabel
        control={
          <Switch
            color="primary"
            checked={checked}
            onChange={handleChange}
            disabled={disabled}
            data-cy={dataCy}
          />
        }
        label={label}
      />
      {error && (
        <FormHelperText className={classes.errorText} error>
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default BooleanInput;
